module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 42
// module chunks = 9